import { Pipe, PipeTransform } from '@angular/core';

/**
 * An Angular pipe that converts dates/timestamps to User Timezone format.
 * Takes a string or Date input, interprets it as UTC, and formats it using the browser's locale
 * with 12-hour time notation.
 * */
@Pipe({
  name: 'LocalDate',
  standalone: true
})
export class LocatedTimePipe implements PipeTransform {
  transform(value: string | Date): unknown {
    const date = new Date(value);
    const DateUtc = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );

    // Set default values for locale and time zone if not provided by the browser
    const locale = navigator.language ?? 'en-US';
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/New_York';
    // Set default options for the DateTimeFormat object
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: zone
    };
    console.error(zone);
    return new Intl.DateTimeFormat(locale, options).format(DateUtc);
  }
}
